import { useState, useCallback } from 'react';

const useReference = () => {
    const [elemRef, setElemRef] = useState(null);
    const measuredRef = useCallback(node => {
        if (node !== null) {
            setElemRef(node);
        }
    }, []);
    return { elemRef, measuredRef };
};

export default useReference;
